/**
 * 查看培训记录
 * @author xyguo
 * @date 2021-3-16
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol,WizSpin } = component_tool;
let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let { $$, checkStrLength } = utils_tool;
import '../../../../styles/containers/train/path/requirement/style.less'
class LookUpInfo extends WizContainer {

  componentName = 'LookUpInfo';

  constructor(props) {
    super(props);
    this.state = {
      dataDetail:[],
    }
  }

  _componentDidMount() {
    if(this.props.record && this.props.record.id){
      this.doAction({
        path: "requirementRecord/getList",
        payload: {
          key: "requirementRecord@getList"+this.props.record.id,
          apiParams: { pushRequirementDataId: this.props.record.id },
        },
      });
    }
  }

  propsAndStateOnChange = {
    detail: this._getList.bind(this),
  };

  _getList(nextProps, nextState) {
    if (nextProps.detail.code === 1) {
      nextState.dataDetail = [...nextProps.detail.data]
    } else {
      wizNotice.error(nextProps.detail.msg);
    }
  }


  _rowView(title, value) {
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={6}>{title}:</WizCol>
        <WizCol offset={1} span={13}>{value}</WizCol>
      </WizRow>
    )
  }

  _rowTitleView(title) {
    return (
      <WizRow className="look-row">
        <WizCol offset={1} span={1} >
          <div className='requirementRecord'></div>
        </WizCol>
        <WizCol span={20} ><strong>{title}</strong></WizCol>
      </WizRow>
    )
  }


  _infoView(dataDetail){
    let certInfo = <></>;
    let pathInfo = <></>;
    let offlineProgram = <></>;
    let personnnelAssessment = <></>; //PERSONNELASSESSMENT
    if(dataDetail && dataDetail.length>0){
      dataDetail.forEach(element => {
        if(element.type===1){
          certInfo = <div className="menu-item">
          {this._rowTitleView('认证')}
          {this._rowView('认证名称', element.entityName)}
          {this._rowView('通过状态', element.status===1 ? "待认证":"已认证")}
           </div>
        }else if(element.type===0){
          pathInfo =<div className="menu-item">
          {this._rowTitleView('路径阶段')}
          {this._rowView('路径阶段名称', element.entityName)}
          {this._rowView('完成进度', element.pathPercentage)}
          {this._rowView('完成状态', element.status===1 ? "未完成":"完成")}
        </div>
        }else if(element.type===2){
          offlineProgram = <div className="menu-item">
          {this._rowTitleView('线下课程')}
          {this._rowView('课程名称', element.entityName)}
          {this._rowView('通过状态', element.status===1 ? "已通过":"未通过")}
           </div>
        }else if(element.type===3){
          personnnelAssessment = <div className="menu-item">
          {this._rowTitleView('人员测评')}
          {this._rowView('总经理', element.entityName)}
          {this._rowView('测评结果', element.status===1 ? "已通过":"未通过")}
           </div>
        }
      });
    }
    return <>{pathInfo}{certInfo}{offlineProgram}{personnnelAssessment}</>
  }
  

  render() {
    const {requirementRecordLoading } = this.props;
    let dataDetail = this.state.dataDetail;
    return <WizSpin tip={'加载中'} spinning={requirementRecordLoading}>
              <div className="menu-item">
                {this._infoView(dataDetail)}
              </div>
        </WizSpin> 
  }
}

const mapStateToProps = (state, ownProps) => {
  const { requirementRecord } = state;
  const detail = modelUtils.getModelEntity(requirementRecord, `requirementRecord@getList`+ownProps.record.id);
  const load = modelUtils.getLoadingState(state, "requirementRecord");
  return {
    detail,
    ...load,
  };
};

export default connect(mapStateToProps)(LookUpInfo);

